<template>
  <v-row style="justify-content: space-between">
    <v-btn v-if="cell.eigenschadenVisible" text @click="onEigenschadenClick"><v-icon left> mdi-arrow-right </v-icon>{{$t('unfalldesk.Eigenschaden')}}</v-btn>
    <v-btn v-if="cell.fahrgastunfallVisible" text @click="onFahrgastunfallClick"><v-icon left> mdi-arrow-right </v-icon>{{$t('unfalldesk.Fahrgastunfall')}}</v-btn>
    <v-btn v-if="cell.protokollModusVisible" text @click="onProtokollClick"><v-icon left> mdi-arrow-right </v-icon>{{$t('unfalldesk.Protokoll')}}</v-btn>
  </v-row>
</template>

<script>
export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  computed: {
    formInput() {
      return this.$store.state[this.namespace].formInput;
    },
    active: {
      get() {
        return this.$store.state[this.namespace].active;
      },
      set(val) {
        this.$store.state[this.namespace].active = val;
      },
    },
  },
  methods: {
    onEigenschadenClick() {
      this.active = { name: 'udEigenschaden', index: 0 };
      this.formInput.type = 'Eigenschaden';
    },
    onFahrgastunfallClick() {
      this.active = { name: 'udFahrgastunfall', index: 0 };
      this.formInput.type = 'Fahrgastunfall';
    },
    onProtokollClick() {
      this.active = { name: 'udProtokoll', index: 0 };
      this.formInput.type = 'Protokoll';
    },
  },
};
</script>
